import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

class DayjsService {
  private dayjs: any
  constructor() {
    this.dayjs = dayjs
    this.dayjs.extend(utc)
    this.dayjs.extend(timezone)
    this.dayjs.tz.setDefault('UTC')
  }

  public getDayjs() {
    return this.dayjs
  }

  public convertUtcTimestampToTZ(timestamp: number, format: string) {
    const ts = timestamp * 1000
    return this.dayjs.tz(dayjs(ts).format(format)).local().format(format)
  }
}

export const dayjsService = new DayjsService()
